var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "adviceDutyBloc" } },
    [
      _c("header-signature", { attrs: { text: _vm.adviceDuty.title } }),
      _vm._v(" "),
      _vm.adviceDuty.subtitle
        ? _c("p", {
            staticClass: "lead fw-bold text-mw",
            domProps: { innerHTML: _vm._s(_vm.adviceDuty.subtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6 col-xl-4" },
          [
            _c("ob1-cards", [
              _c(
                "div",
                { staticClass: "row px-3 py-1 py-md-2" },
                [
                  _c("variation-detail", {
                    attrs: {
                      "next-url": _vm.adviceDuty.selectedVariation.nextUrl,
                      label: _vm.adviceDuty.tileTitle,
                      "banner-label": _vm.adviceDuty.selectedVariation.banner,
                      "price-block":
                        _vm.adviceDuty.selectedVariation.priceBlockDTO,
                      "button-label":
                        _vm.adviceDuty.selectedVariation.buttonLabel,
                      attributes: _vm.adviceDuty.selectedVariation.attributes,
                      "contract-infos": _vm.adviceDuty.contractInfos,
                      "button-track-zone": "assurance_conseillee",
                      "button-track-nom": "ajouter_cette_assurance",
                      "button-track-cible": _vm.selectedVarationTrackCible,
                      "details-popin":
                        _vm.adviceDuty.selectedVariation.detailsPopin,
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 col-xl-8" },
          [
            _c("ob1-message-alerte", {
              staticClass: "pt-1 pt-md-0 text-mw",
              attrs: {
                title: _vm.adviceDuty.messages.info,
                icon: "icon-info",
                type: "info",
              },
            }),
            _vm._v(" "),
            _c("recommended-device-value-help", {
              attrs: {
                title: _vm.adviceDuty.messages.title,
                text: _vm.adviceDuty.messages.text,
                "picture-dto": _vm.adviceDuty.picture,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.adviceDuty.selectedVariation.detailsPopin
        ? _c("variation-details-popin", {
            attrs: {
              dto: _vm.adviceDuty.selectedVariation.detailsPopin,
              "button-track-cible": _vm.selectedVarationTrackCible,
              "button-track-zone": "assurance_conseillee",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }